export const Apps: Record<string, {
  name: string;
  endpoint: string;
  urls?: {
    profile?: string | null;
  };
  placeholders?: {
    url?: string;
    example?: string;
  };
  pinnedWidget?: {
    enabled: boolean;
  };
  priceId: string;
}> = {
  'google-reviews': {
    name: 'Google',
    endpoint: "https://wix.certifiedcode.io/reviews-google",
    urls: {
      profile: null
    },
    placeholders: {
      url: "e.g. Starbucks, 1499 Washington Ave, San Leandro"
    },
    pinnedWidget: {
      enabled: true
    },
    priceId: 'pri_01jkr25fhhmc7wpepckhx7v9c3'
  },
  'etsy-reviews': {
    name: 'Etsy',
    endpoint: "https://wix.certifiedcode.io/reviews-etsy",
    urls: {
      profile: null
    },
    placeholders: {
      url: "e.g. https://www.etsy.com/shop/YourShopName"
    },
    pinnedWidget: {
      enabled: true
    },
    priceId: 'pri_01jm1fhhgcp6y9bnqyjavts8q4'
  },
  'amazon-reviews': {
    name: 'Amazon',
    endpoint: "https://wix.certifiedcode.io/reviews-amazon",
    urls: {
      profile: null
    },
    placeholders: {
      url: "e.g. https://www.amazon.com/dp/YourProductID"
    },
    pinnedWidget: {
      enabled: true
    },
    priceId: 'pri_01jkr25fhhmc7wpepckhx7v9c5'
  },
  'tripadvisor-reviews-dev': {
    name: "TripAdvisor",
    endpoint: "https://wix.certifiedcode.io/reviews-tripadvisor",
    urls: {
      profile: null
    },
    placeholders: {
      url: "https://www.tripadvisor.com/Hotel_Review-g187147-d197666-Reviews-Hotel_Ares_Paris-Paris_Ile_de_France.html"
    },
    priceId: 'pri_01jmbf67j74fbaw3bmn8m68mxw'
  },
};